import { useState } from 'react';
import { telechargerExcel } from '../services/exportService';

/**
 * Bouton « Export Excel » des listes.
 *
 * Il passe les filtres de l'écran au serveur, qui rejoue la même liste : le
 * classeur contient ce que la page montre, toutes pages confondues — pas la
 * seule page affichée, ce qui serait une surprise désagréable.
 */
function BoutonExport({ chemin, filtres, libelle = 'Export Excel', titre }) {
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState(null);

  async function exporter() {
    setEnCours(true);
    setErreur(null);
    try {
      await telechargerExcel(chemin, filtres);
    } catch (err) {
      setErreur(err.message || 'Export impossible.');
    } finally {
      setEnCours(false);
    }
  }

  return (
    <button
      type="button"
      className="devis-btn"
      onClick={exporter}
      disabled={enCours}
      title={erreur || titre || 'Télécharger la liste filtrée au format Excel (.xlsx)'}
    >
      {enCours ? 'Export en cours' : erreur ? 'Réessayer l’export' : libelle}
    </button>
  );
}

export default BoutonExport;
